import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Helper function to get user profile picture URL
export function getUserProfilePicture(user: any): string {
  // Try multiple possible locations for profile picture
  const possiblePaths = [
    user.user_metadata?.picture,
    user.user_metadata?.avatar_url,
    user.user_metadata?.avatar,
    user.user_metadata?.image,
    user.user_metadata?.photo,
    user.identities?.[0]?.identity_data?.picture,
    user.identities?.[0]?.identity_data?.avatar_url,
    user.identities?.[0]?.identity_data?.avatar,
  ];

  // Return the first valid URL found
  for (const path of possiblePaths) {
    if (path && typeof path === 'string' && path.startsWith('http')) {
      return path;
    }
  }

  // Fallback to placeholder
  return '/placeholder.svg';
}
